<template>
  <div>
    <NavBar/>
    <div class="min-height-page">
    <v-main class="third-bg " v-if="isContentLoaded" >
      <div>
        <div class="container-fluid container-md py-10">
          <div class="row">
            <div class="col-12 text-center">
              <h1>
                <span class="font-19 border-bottom-gold px-5">{{ servicesTitle }}</span>
                <v-img v-if="pageContent.MainOriginalFileUrl !== null"
                       :src="$replaceHttps(pageContent.MainOriginalFileUrl)" height="300" contain class="mt-5"></v-img>
              </h1>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h5 class="text-center mb-5">{{ pageContent.mainTitle }}</h5>
              <div v-html="pageContent.Description"></div>
            </div>
            <div class="col-12 mt-5">
              <div class="text-center font-19">
                {{ pageContent.SecondSectionTitle }}
              </div>
            </div>
            <div class="col-12" dir="ltr" id="servicePage">
              <!--            <carousel
                              :autoplay="true"
                              :dots="false"
                              :items="4"
                              :loop="false"
                              :margin="15"
                              :nav="false"
                              :responsive="{0:{items:1,nav:false},600:{items:2,nav:false}
                                    ,900:{items:3,nav:false},1200:{items:4,nav:false}}"
                              class="py-0">
                            <div v-for="(item,i) in pageContent.gallery" :key="i">
                              <v-img :src="$replaceHttps(item.smallSrc)"></v-img>
                            </div>
                          </carousel>-->
              <silent-box :gallery="pageContent.gallery" id="silentBox"></silent-box>
            </div>
            <div class="col-6" v-if="pageContent.PresentPrice !== 0">
              <v-alert color="primary" outlined><span
                  class="black--text">قیمت حضوری: {{ (pageContent.PresentPrice) }}</span></v-alert>
            </div>
            <div class="col-6" v-if="pageContent.NonPresentPrice !== 0">
              <v-alert color="primary" outlined><span
                  class="black--text">قیمت غیرحضوری: {{ pageContent.NonPresentPrice }}</span></v-alert>
            </div>
            <div class="col-12 mt-8">
              <div class="text-center font-18">درخواست {{ servicesTitle }}</div>
              <div class="text-center mt-3 light-gray-text ">جهت کسب اطلاعات بیشتر می توانید فرم زیر را پر نمایید تا با
                شما
                تماس بگیریم و در مورد جزئیات آن بیشتر صحبت کنیم.
              </div>
            </div>
            <div class="col-7 mx-auto">
              <div class="mb-4"><i class="primary-text fa-duotone fa-user ml-2"></i>نام و نام خانوادگی:</div>
              <v-text-field
                  v-model="nameAndFamily"
                  class=" mb-1"
                  dense
                  hide-details
                  flat
                  solo>
              </v-text-field>
              <div v-if="nameAndFamily === ''" class="font-12 py-2 red-color">پرکردن فیلد بالا الزامی است.</div>
              <div class="mb-4"><i class="primary-text fa-duotone fa-mobile-button ml-2"></i>شماره تماس:</div>
              <v-text-field
                  v-model="phoneNumber"
                  type="text"
                  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
                  class=" mb-1"
                  dense
                  :rules="phoneRules"
                  flat
                  solo>
              </v-text-field>
              <div v-if="phoneNumber === ''" class="font-12 py-2 red-color">پرکردن فیلد بالا الزامی است.</div>

              <div class="mb-4"><i class="primary-text fa-duotone fa-user ml-2"></i>زمینه فعالیت:</div>
              <v-text-field
                  v-model="activity"
                  class=" mb-1"
                  dense
                  flat
                  solo>
              </v-text-field>
              <div v-if="activity === ''" class="font-12 py-2 red-color">پرکردن فیلد بالا الزامی است.</div>

              <div class="mb-4"><i class="primary-text fa-duotone fa-user ml-2"></i>توضیحات:</div>
              <v-textarea
                  v-model="description"
                  class=" mb-1"
                  dense
                  flat
                  solo>
              </v-textarea>
              <div class="text-center">
                <v-btn color="primary" elevation="0" class="rounded-lg" @click="submitDialog"
                       :disabled="nameAndFamily === '' || phoneNumber === '' || activity === ''">
                  ثبت درخواست
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-main>
    </div>
    <FooterComponent/>
    <v-dialog
        v-model="showResultDialog"
        hide-overlay
        persistent
        width="530">
      <v-card class="text-center">
        <v-card-title class="justify-space-between secondary-bg">
          <v-btn
              color="primary"
              icon
              @click="showResultDialog = false">
            <i class="fas fa-times ml-1"></i>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-6">
          <div class="mb-0 black--text py-5">{{ dialogResult }}</div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-overlay
        v-model="showLoaderDialog"
        persistent
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>

// import carousel from "vue-owl-carousel";

import NavBar from "@/Academy/components/NavBar";
import FooterComponent from "@/Academy/components/Footer";


export default {
  name: "Services",
  metaInfo () {
    return {
      title: window.projectName +  this.servicesTitle,
      meta: [
        { //  set meta
          name: 'keywords',
          content: this.$keywords
        },
        { //  set meta
          name: 'description',
          content: this.$description
        },
        {
          property: 'og:title',
          content: window.projectName + this.servicesTitle,
          vmid: 'og:title'

        },
        {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        },
        {
          property: 'og:description',
          content: this.$description,
          vmid: 'og:description'
        },
        {
          property: 'og:image',
          content: this.$defaultImage,
          vmid: 'og:image'
        },
        {
          property: 'twitter:title',
          content: window.projectName +  this.servicesTitle,
          vmid: 'twitter:title'
        },
        {
          property: 'twitter:site',
          content: window.location.href,
          vmid: 'twitter:site'
        },
        {
          property: 'twitter:image',
          content: this.$defaultImage,
          vmid: 'twitter:image'
        },
        {
          property: 'twitter:description',
          content: this.$description,
          vmid: 'twitter:description'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.$seoUrl + this.$route.path
        },
        {
          rel: 'image_src',
          href: this.$defaultImage
        }
      ]
    }
  },
  components: {FooterComponent, NavBar},
  data: () => ({
    servicesTitle: null,
    showResultDialog: false,
    isContentLoaded: false,
    showLoaderDialog: false,
    dialogResult: null,
    pageContent: {},
    items: [],
    nameAndFamily: '',
    phoneNumber: '',
    phoneRules: [
      value => (value && value.length === 11) || 'تلفن 11 رقم است.',
    ],
    activity: '',
    description: null,
    isLoggedIn: false,
  }),
  mounted() {
    this.getData()
    this.silentLogin()

    switch (this.$route.query.id) {
      case '1':
        this.servicesTitle = 'مشاوره خصوصی'
        break
      case '2':
        this.servicesTitle = 'فرانچایز'
        break
      case '3':
        this.servicesTitle = 'برگزاری همایش'
        break
      case '4':
        this.servicesTitle = 'برگزاری ورکشاپ در شهر شما'
        break
      case '5':
        this.servicesTitle = 'دریافت نمایندگی'
        break
      case '6':
        this.servicesTitle = 'ساخت آژانس املاک'
        break
      case '7':
        this.servicesTitle = 'صدور مدارک فنی حرفه ای و بین المللی'
        break
      case '8':
        this.servicesTitle = 'خدمات حقوقی مسکن و املاک'
        break
      case '9':
        this.servicesTitle = 'هوشمندسازی فایلینگ املاک'
        break
      case '10':
        this.servicesTitle = 'ساخت و اپلیکیشن املاک'
        break
      case '11':
        this.servicesTitle = 'ایران زیلو'
        break
      case '12':
        this.servicesTitle = 'اعضای باشگاه ایران زیلو'
        break
      case '13':
        this.servicesTitle = 'مدارک و تحصیلات'
        break
      case '14':
        this.servicesTitle = 'نمونه مدارک'
        break

    }
  },
  watch: {
    '$route.query.id'() {
      location.reload()
    }
  },
  methods: {
    submitDialog() {
      this.showLoaderDialog = true
      if (this.isLoggedIn) {
        let myHeaders = new Headers();
        myHeaders.append("Authorization", this.$getUserData().token);

        let formdata = new FormData();
        formdata.append("NameAndFamily", this.nameAndFamily);
        formdata.append("PhoneNumber", this.phoneNumber);
        formdata.append("WorkingField", this.activity);
        formdata.append("Description", this.description);
        formdata.append("TypeSpecificPage", this.$route.query.id);

        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };

        fetch(this.$baseUrl + "/Client/SubmitSpecificPageForm", requestOptions)
            .then(response => response.text())
            .then(result => {
              this.showLoaderDialog = false
              this.dialogResult = result
              this.showResultDialog = true
            })
            .catch(error => console.log('error', error));
      } else {
        this.dialogResult = 'برای ثبت درخواست ابتدا باید وارد سایت شوید.'
        this.showResultDialog = true
      }

    },
    getData() {
      let resStatus = null

      this.showLoaderDialog = true
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/SpecificPage?typeSpecificPage=" + this.$route.query.id, requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              let json = JSON.parse(result)
              this.pageContent = json
              let gallery = [];
              if (json.Gallery1OriginalFileUrl !== null) {
                gallery.push({
                  src: json.Gallery1OriginalFileUrl,
                  description: '',
                  alt: '',
                  thumbnailWidth: '220px',
                  thumbnailHeight: '220px',
                });
              }
              if (json.Gallery2OriginalFileUrl !== null) {
                gallery.push({
                  src: json.Gallery2OriginalFileUrl,
                  description: '',
                  alt: '',
                  thumbnailWidth: '220px',
                  thumbnailHeight: '220px',
                });
              }
              if (json.Gallery3OriginalFileUrl !== null) {
                gallery.push({
                  src: json.Gallery3OriginalFileUrl,
                  description: '',
                  alt: '',
                  thumbnailWidth: '220px',
                  thumbnailHeight: '220px',
                });
              }
              if (json.Gallery4OriginalFileUrl !== null) {
                gallery.push({
                  src: json.Gallery4OriginalFileUrl,
                  description: '',
                  alt: '',
                  thumbnailWidth: '220px',
                  thumbnailHeight: '220px',
                });
              }
              if (json.Gallery5OriginalFileUrl !== null) {
                gallery.push({
                  src: json.Gallery5OriginalFileUrl,
                  description: '',
                  alt: '',
                  thumbnailWidth: '220px',
                  thumbnailHeight: '220px',
                });
              }
              if (json.MainOriginalFileUrl !== null) {
                gallery.push({
                  src: json.MainOriginalFileUrl,
                  description: '',
                  alt: '',
                  thumbnailWidth: '220px',
                  thumbnailHeight: '220px',
                });
                json.gallery = gallery;
                this.isContentLoaded = true
              }
            }
            else {
              this.dialogResult = result
              this.showResultDialog = true
            }
            this.showLoaderDialog = false

          })
          .catch(error => console.log('error', error));
    },
    silentLogin() {
      let userData = this.$getUserData()
      if (userData.mobile !== '' && userData.activeCode !== '' && userData.mobile !== undefined && userData.activeCode !== null) {
        let resStatus = null
        let myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        let urlencoded = new URLSearchParams();
        urlencoded.append("PhoneNumber", userData.mobile);
        urlencoded.append("VerifyCode", userData.activeCode);

        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow'
        };

        fetch(this.$baseUrl + "/Client/LoginRegister", requestOptions)
            .then(response => {
              resStatus = response.status
              return response.text()
            })
            .then(result => {
              this.showLoaderDialog = false
              if (resStatus === 200) {
                let json = JSON.parse(result)
                let token = 'Bearer ' + json.JwtToken
                this.$setUserData(userData.mobile, userData.activeCode, token, json.Role);
                this.isLoggedIn = true;
                if (json.Role === 1 || json.Role === 2 || json.Role === 3) {
                  this.$router.replace({path: '/Dashboard'})
                }
              } else {
                this.isLoggedIn = false
              }
            })
            .catch(error => console.log('error', error));
      } else {
        this.isLoggedIn = false
      }


    },
  }
}
</script>

<style scoped>

</style>
